import ChatbotAPIService from '@/js/api/chatbot/chatbot';

// Main function to get chatbot response
export const getChatbotResponse = async (userMessage, chatHistory = []) => {
  try {
    const response = await ChatbotAPIService.sendMessage({
      message: userMessage,
      chat_history: chatHistory
    });

    if (response.data && response.data.response) {
      return response.data.response;
    } else {
      throw new Error('Invalid response format from chatbot API');
    }
  } catch (error) {
    console.error('Chatbot API Error:', error);
    // Fallback response when API is not available
    return `I apologize, but I'm currently unable to process your request. Please try again later or contact support at support@ordercircle.com. Error: ${error.message}`;
  }
};

// Check Azure OpenAI status
export const checkAzureStatus = async () => {
  try {
    const response = await ChatbotAPIService.testConnections();
    
    if (response.data && response.data.azure_openai) {
      return response.data.azure_openai.connected;
    }
    
    return false;
  } catch (error) {
    console.error('Azure Status Check Error:', error);
    return false;
  }
};

// Format message content for display
export const formatMessageContent = (content, isDarkMode = false) => {
  if (!content) return '<p>...</p>';
  
  // Convert markdown-like formatting to HTML
  let formatted = content
    // Bold text
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    // Italic text
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    // Code blocks
    .replace(/```(.*?)```/gs, '<pre><code>$1</code></pre>')
    // Inline code
    .replace(/`(.*?)`/g, '<code>$1</code>')
    // Line breaks
    .replace(/\n/g, '<br>')
    // Links
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  
  // Wrap in paragraphs if not already wrapped
  if (!formatted.includes('<p>') && !formatted.includes('<pre>')) {
    formatted = `<p>${formatted}</p>`;
  }
  
  return formatted;
}; 